import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';

interface StyledBoxProps extends BoxProps {
}

export const ModalBody = styled(Box, { 
    shouldForwardProp: (prop) => prop !== 'selected' 
})<StyledBoxProps>(({ theme }) => ({   
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    backgroundColor: '#fff',
    padding: 16
}));